import React, { Component } from 'react';
import { Field } from 'redux-form';
import shortid from 'shortid';
import styled from 'styled-components';

import { colors } from '../../../shared/styles';
import S3Upload from './S3Upload';

const StyledMultiS3Uploader = styled.div`
    color: ${colors.grey.default};
    padding-left: 20px;

    & .add-btn {
        display: inline-block;
        color: ${colors.white};
        background: ${colors.orange.default};
        padding: 10px;
        border-radius: 4px;
        border: none;
    }

    & .scroll-img {
        width: 700px;
        white-space: nowrap;
        text-align: left;
        margin-bottom: 20px;

        .image_preview {
            margin-bottom: 10px;
            height: 140px;
            width: 100%;
            display: block;
            position: relative;
            overflow: hidden;
            background-position: 50% 50%;
            background-size: cover;
            background-repeat: no-repeat;
        }
    }

    & .img-overflow {
        overflow-x: scroll;
        overflow-y: hidden;
        min-height: 100%;
        margin: 10px 0;
    }

    & .img-item {
        display: inline-block;
        width: 35%;
    }

    & .filename {
        text-overflow: ellipsis;
        overflow: hidden;
    }

    & .img-item > div {
        padding: 10px 10px 10px 0;
    }
`;

class MultiS3UploadField extends Component {
    constructor(props) {
        super(props);

        this.bindScroller = this.bindScroller.bind(this);
        this.onAddField = this.onAddField.bind(this);
    }

    bindScroller(c) {
        this._scroller = c;
    }

    onAddField() {
        const { fields } = this.props;

        fields.push({});

        setTimeout(() => {
            this._scroller.scrollLeft = this._scroller.scrollWidth;
        }, 200);
    }

    render() {
        const {
            fields,
            assetType,
            accept,
            maxFileSize,
            addText,
            fieldName,
        } = this.props;

        return (
            <StyledMultiS3Uploader>
                <div className="scroll-img">
                    <div ref={this.bindScroller} className="img-overflow">
                        {fields.map((field, index) => {
                            // generate random id and use this at part of react key prop
                            // gaurentees rerender!
                            const id = shortid.generate();

                            return (
                                <div
                                    className="img-item"
                                    key={`${field}.${fieldName}.${id}.${index}`}
                                >
                                    <Field
                                        name={`${field}.${fieldName}`}
                                        accept={accept}
                                        assetType={assetType}
                                        maxFileSize={maxFileSize}
                                        component={S3Upload}
                                        onRemove={() => fields.remove(index)}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="maxWidth">
                    <button
                        className="add-btn"
                        type="button"
                        onClick={this.onAddField}
                    >
                        {addText}
                    </button>
                </div>
            </StyledMultiS3Uploader>
        );
    }
}

export default MultiS3UploadField;



// WEBPACK FOOTER //
// ./src/components/shared/forms/MultiS3Upload.js